// assets/custom-no-redirect.js
(function () {
  /* --------------------------- small toast --------------------------- */
  function toast(msg) {
    const t = document.createElement('div');
    t.textContent = msg;
    Object.assign(t.style, {
      position: 'fixed', bottom: '20px', right: '20px',
      padding: '12px 16px', background: '#111', color: '#fff',
      borderRadius: '10px', fontSize: '14px', zIndex: 99999,
      opacity: 0, transition: 'opacity .2s ease'
    });
    document.body.appendChild(t);
    requestAnimationFrame(() => (t.style.opacity = 1));
    setTimeout(() => { t.style.opacity = 0; setTimeout(() => t.remove(), 220); }, 1800);
  }

  /* ------------- gather sections Concept wants to re-render ---------- */
  function gatherCartSections() {
    const sections = [];
    // Let theme code push section IDs into this array
    document.documentElement.dispatchEvent(
      new CustomEvent('cart:bundled-sections', { bubbles: true, detail: { sections } })
    );

    // Fallbacks: include header sections if nothing replied
    if (sections.length === 0) {
      // Any section within header-group
      document.querySelectorAll('header, header-group, .header-group').forEach(headerRoot => {
        headerRoot.querySelectorAll('[id^="shopify-section-"][data-section-id]').forEach(sec => {
          const id = sec.getAttribute('data-section-id');
          if (id) sections.push(id);
        });
      });
    }

    // Final dedupe/cleanup
    return Array.from(new Set(sections)).filter(Boolean);
  }

  /* ------------------ fetch & replace section HTML ------------------- */
  function refreshSections(sectionIds) {
    if (!sectionIds || sectionIds.length === 0) return Promise.resolve();

    const url = `/?sections=${encodeURIComponent(sectionIds.join(','))}`;
    return fetch(url, { headers: { 'Accept': 'application/json' } })
      .then(r => r.json())
      .then(payload => {
        Object.keys(payload).forEach(id => {
          const target =
            document.getElementById(`shopify-section-${id}`) ||
            document.querySelector(`[data-section-id="${id}"]`);
          if (!target) return;

          // Parse incoming section HTML safely
          const doc = new DOMParser().parseFromString(payload[id], 'text/html');
          const incoming = doc.body.firstElementChild; // usually the <section id="shopify-section-...">
          if (!incoming) return;

          // Replace inner contents (preserve outer node/listeners where possible)
          target.innerHTML = incoming.innerHTML;
        });
      })
      .catch(err => console.error('Section refresh failed', err));
  }

  /* --------------- simple numeric fallback (not relied on) ---------- */
  function updateCartCountFallback(cart) {
    const count = cart?.item_count ?? 0;
    document.querySelectorAll('.cart-count, [data-cart-count]').forEach(el => {
      el.textContent = count;
    });
    // Bubbles that hide at 0
    document.querySelectorAll('.cart-count-bubble, .cart-link__bubble, [data-cart-bubble]').forEach(b => {
      if (count > 0) b.classList.remove('hidden', 'opacity-0', 'invisible');
      else b.classList.add('hidden');
    });
  }

  /* -------------------------- AJAX add flow -------------------------- */
  function ajaxAdd(form) {
    const submit = form.querySelector('[type="submit"], button[name="add"]');
    if (submit) submit.setAttribute('aria-busy', 'true');

    const fd = new FormData(form);

    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { Accept: 'application/json' },
      body: fd
    })
      .then(res => (res.ok ? res.json() : res.json().then(err => Promise.reject(err))))
      .then(item =>
        fetch('/cart.js')
          .then(r => r.json())
          .then(cart => {
            // Fallback numeric update immediately
            updateCartCountFallback(cart);

            // Ask theme which sections to refresh (header, etc.)
            const sections = gatherCartSections();

            // Refresh those sections so the theme’s badge updates correctly
            return refreshSections(sections).then(() => {
              // Fire theme-style events so anything listening stays in sync
              try {
                document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart } }));
                if (window.theme?.pubsub?.publish) {
                  window.theme.pubsub.publish(window.theme.pubsub.PUB_SUB_EVENTS.cartUpdate, { cart });
                }
                document.dispatchEvent(new CustomEvent('cart:added', { detail: { item, cart } }));
              } catch (_) {}
              toast(`${item.title} added to cart`);
            });
          })
      )
      .catch(err => alert((err && err.description) || 'Could not add to cart'))
      .finally(() => submit && submit.removeAttribute('aria-busy'));
  }

  /* --------------- identify add-to-cart intent on button ------------- */
  function isATCButton(node) {
    return !!node && node.closest &&
      node.closest('button[name="add"], [data-add-to-cart], .product-form__submit, .add-to-cart, [data-product-atc]');
  }
  function isATCForm(form) {
    if (!form) return false;
    const action = (form.getAttribute('action') || '');
    return action.includes('/cart/add') || !!form.querySelector('input[name="id"]');
  }

  /* --------- (optional) block forced nav to /cart if triggered ------- */
  (function blockCartRedirects() {
    const origAssign = location.assign.bind(location);
    const origReplace = location.replace.bind(location);
    window.__allowCartRedirect__ = false;
    location.assign = function (url) {
      if (!window.__allowCartRedirect__ && typeof url === 'string' && url.indexOf('/cart') !== -1) return;
      return origAssign(url);
    };
    location.replace = function (url) {
      if (!window.__allowCartRedirect__ && typeof url === 'string' && url.indexOf('/cart') !== -1) return;
      return origReplace(url);
    };
    const origOpen = window.open;
    window.open = function (url, name, specs) {
      if (!window.__allowCartRedirect__ && typeof url === 'string' && url.indexOf('/cart') !== -1) return null;
      return origOpen.call(window, url, name, specs);
    };
  })();

  /* ---- intercept clicks & submits in capture phase (runs first) ----- */
  ['pointerdown','mousedown','touchstart','click'].forEach(type => {
    document.addEventListener(type, function (e) {
      const btn = isATCButton(e.target) && e.target.closest('button, a, input');
      if (!btn) return;

      const form = btn.form || btn.closest('form');
      if (!isATCForm(form)) return;
      if (form.hasAttribute('data-allow-redirect')) return;

      e.preventDefault();
      e.stopImmediatePropagation();
      ajaxAdd(form);
    }, true);
  });

  document.addEventListener('submit', function (e) {
    const form = e.target.closest('form');
    if (!isATCForm(form)) return;
    if (form.hasAttribute('data-allow-redirect')) return;

    e.preventDefault();
    e.stopImmediatePropagation();
    ajaxAdd(form);
  }, true);
})();